import Vue from 'vue';
import VueRouter from 'vue-router';
import { PLoginCasCallback } from 'pioneira-ui';
import { store } from 'pioneira-ui';

Vue.use(VueRouter);

const routes = [
  {
    path: '/acesso',
    name: 'Acesso',
    meta: {
      routeBack: '/acesso',
      routeBackTitle: 'Acesso',
      title: 'Acesso',
      hideLayout: true,
    },
    component: () => import('@/views/Acesso.vue'),
  },
  {
    path: '/login-callback',
    name: 'LoginCallback',
    component: PLoginCasCallback,
  },
  {
    path: '/propostas',
    name: 'ViewListPropostas',
    meta: {
      routeBack: '/propostas',
      routeBackTitle: 'Propostas',
      title: 'Propostas',
    },
    component: () => import('@/views/ViewListPropostas.vue'),
  },
  {
    path: '/propostas/nova-simulacao',
    name: 'ViewSimulacaoChat',
    meta: {
      routeBack: '/propostas',
      routeBackTitle: 'Simulação de Crédito',
      title: 'Simulação de Crédito',
    },
    component: () => import('@/views/ViewSimulacaoChat.vue'),
  },
  {
    path: '/propostas/resultado-simulacao',
    name: 'ViewSimulacaoResultado',
    meta: {
      routeBack: '/propostas',
      routeBackTitle: 'Simulação de Crédito',
      title: 'Simulação de Crédito',
    },
    component: () => import('@/views/ViewSimulacaoResultado.vue'),
  },
  {
    path: '/propostas/confirmar-dados-simulacao',
    name: 'ViewPreContratacao',
    meta: {
      routeBack: '/propostas',
      routeBackTitle: 'Simulação de Crédito',
      title: 'Contratação de Crédito',
    },
    component: () => import('@/views/ViewPreContratacao.vue'),
  },
  {
    path: '/politica-cookies',
    name: 'CookiesPolicy',
    meta: {
      title: 'Política de Cookies',
      cookiesPolicy: true,
      hideLayout: true,
    },
    component: () => import('../components/PoliticaCookies.vue'),
  },
  {
    path: '/politica-privacidade',
    name: 'PrivacyPolicy',
    meta: {
      title: 'Política de Privacidade',
      privacyPolicy: true,
      hideLayout: true,
    },
    component: () => import('../components/PoliticaPrivacidade.vue'),
  },
  {
    path: '/propostas/contratacao/:id/:tab?',
    name: 'ViewContratacao',
    meta: {
      routeBack: '/propostas',
      routeBackTitle: 'Simulação de Crédito',
      title: 'Contratação de Crédito',
    },
    component: () => import('@/views/contratacao/ViewContratacao.vue'),
  },
  {
    path: '/propostas/contratacao/acompanhamento/:id/:tab?',
    name: 'ViewAcompanhamento',
    meta: {
      routeBack: '/propostas',
      routeBackTitle: 'Acompanhamento da Proposta',
      title: 'Contratação de Crédito',
    },
    component: () => import('@/views/ViewAcompanhamento.vue'),
  },
  {
    path: '/notas-fiscais',
    name: 'ViewNotasFiscais',
    meta: {
      routeBack: '/notas-fiscais',
      routeBackTitle: 'Notas Fiscais',
      title: 'Contratação de Crédito',
    },
    component: () => import('@/views/notasFiscais/ViewNotasFiscais.vue'),
  },
  {
    path: '/nota-fiscal/:id',
    name: 'Visualizar',
    meta: {
      routeBack: '/notas-fiscais',
      routeBackTitle: 'Notas Fiscais',
      title: 'Contratação de Crédito',
    },
    component: () => import('@/views/notasFiscais/visualizar.vue'),
  },
  {
    path: '/caf-mobile/:token',
    name: 'CafMobile',
    component: () => import('@/views/contratacao/CafMobile.vue'),
    meta: {
      hideLayout: true,
      title: 'CAF Mobile',
    },
  },
  {
    path: '/docusign/link-assinatura/:token',
    name: 'LinkAssinaturaQrCode',
    component: () => import('@/views/LinkAssinaturaQrCode.vue'),
    meta: {
      hideLayout: true,
      title: 'Assinar por QR Code',
    },
  },
  {
    path: '/consulta-de-saldo/:id?',
    name: 'Consulta de saldo a quitar',
    meta: {
      title: 'Consulta de Saldo',
    },
    component: () => import('@/views/ConsultaSaldo.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

function temUrlParaRedirecionar(from, to) {
  if (
    from.query.redirect == undefined ||
    from.query.redirect == '' ||
    from.query.redirect == '/'
  ) {
    return false;
  }

  if (to.fullPath == from.query.redirect) {
    return false;
  }

  return true;
}

router.beforeEach((to, from, next) => {
  let documentName = to.meta.title;
  const publicRoutes = [
    'Acesso',
    'LoginCallback',
    'CafMobile',
    'LinkAssinaturaQrCode',
    'CookiesPolicy',
    'PrivacyPolicy',
  ];

  if (!publicRoutes.includes(to.name) && !store.getters.isAuthenticated) {
    next({ name: 'Acesso', query: { redirect: to.fullPath } });
    documentName = routes[0].meta.title;
  } else if (
    store.getters.isAuthenticated &&
    temUrlParaRedirecionar(from, to)
  ) {
    next({ path: from.query.redirect });
  } else if (store.getters.isAuthenticated && to.name === 'Acesso') {
    next({ name: 'ViewListPropostas' });
    documentName = routes[2].meta.title;
  } else {
    next();
  }

  if (to.meta.cookiesPolicy || to.meta.privacyPolicy) {
    const existingCookiesPolicyLink = document.querySelector(
      'link[rel="stylesheet"][href*="lgpd-politica-cookies-lib"]'
    );

    const existingPrivacyPolicyLink = document.querySelector(
      'link[rel="stylesheet"][href*="lgpd-politica-privacidade-lib"]'
    );

    if (!existingCookiesPolicyLink || !existingPrivacyPolicyLink) {
      const cookiesPolicyLink = document.createElement('link');
      const privacyPolicyLink = document.createElement('link');

      cookiesPolicyLink.rel = 'stylesheet';
      privacyPolicyLink.rel = 'stylesheet';

      cookiesPolicyLink.href =
        'https://web-static.sicredi.io/lgpd-politica-cookies-lib@1/static/css/main.css';

      privacyPolicyLink.href =
        'https://web-static.sicredi.io/lgpd-politica-privacidade-lib@1/static/css/main.css';

      document.head.appendChild(cookiesPolicyLink);
      document.head.appendChild(privacyPolicyLink);
    }
  }
  
  const existingCookiesModule = document.querySelector(
    'link[rel="stylesheet"][href*="lgpd-consentimento-coleta-cookies-lib"]'
  );

  if (!existingCookiesModule) {
    const cookiesModuleLink = document.createElement('link');

    cookiesModuleLink.rel = 'stylesheet';

    cookiesModuleLink.href =
      'https://web-static.sicredi.io/lgpd-consentimento-coleta-cookies-lib@1/static/css/main.css';

    document.head.appendChild(cookiesModuleLink);
  }

  document.title = `Sicredi - ${documentName}`;
});

export default router;
